module.exports = __webpack_public_path__ + "static/media/scan_image.8c6b2127.jpg";